module.exports = __webpack_public_path__ + "img/viewTemplate.png";